import Vue from 'vue'
import ElementUI, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import './assets/css/index.css'
import './styles/index.less'
import './plugins/element.js'
import './styles/iconfont.js'
// api
import Api from '@/api'
// Loading
//富文本
import VueQuillEditor from 'vue-quill-editor';
//  require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// 地图引入开始
// VueAMap.initAMapApiLoader({
// 	// key: '02a6340a4e3048a606ffbb58d2b4133d', // 19e74ac064a1b0d990be58ee79b64f96  myKey
// 	key: '3757f154011e52251f40f746426894e3', // 企业  
// 	plugin: [
// 		'AMap.Autocomplete', // 输入提示插件
// 		'AMap.PlaceSearch', // POI搜索插件
// 		'AMap.Scale', // 右下角缩略图插件 比例尺
// 		'AMap.OverView', // 地图鹰眼插件
// 		'AMap.ToolBar', // 地图工具条
// 		'AMap.MapType', // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
// 		// 'AMap.PolyEditor', // 编辑 折线多，边形
// 		'AMap.CircleEditor', // 圆形编辑器插件
// 		'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
// 		// 'AMap.TruckDriving', // 路径规划
// 		// 'AMap.Driving',
// 		'AMap.Geocoder' // 地址编译
// 	],
// 	v: '1.4.13'
// })
// Vue.use(VueAMap)
import AMap from 'vue-amap';
Vue.use(AMap);

  // 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '02a6340a4e3048a606ffbb58d2b4133d',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.ToolBar'],
});
// 地图引入结束


Vue.config.productionTip = false
import router from "@/router/index.js"
import {store} from "@/store/store.js"
Vue.use(ElementUI);
//富文本编辑器
Vue.use(VueQuillEditor)
Vue.prototype.Api = Api
import md5 from 'js-md5'  //引入
Vue.prototype.$md5 = md5;  //定义全局变量
// 跳转后返回顶部
router.beforeEach((to, from, next) => {
  if (from.path == "/") {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
  }else{
    next()
  }

})



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
